import { useEffect, useRef } from 'react'

interface IUseDatesSelectedOnModalOpenRefProps {
  isOpen: boolean
  hasDatesSelected: boolean
}

export const useDatesSelectedOnModalOpenRef = ({
  hasDatesSelected,
  isOpen,
}: IUseDatesSelectedOnModalOpenRefProps) => {
  // Keep the "has dates selected" value stable for a single modal session.
  // If we recompute this from live Formik values on every date click, the modal can switch
  // layout branches mid-selection, which remounts the date picker and makes it appear to close.
  const hasDatesSelectedOnModalOpenRef = useRef<boolean | null>(null)

  useEffect(() => {
    if (!isOpen) {
      hasDatesSelectedOnModalOpenRef.current = null
      return
    }

    if (hasDatesSelectedOnModalOpenRef.current === null) {
      hasDatesSelectedOnModalOpenRef.current = hasDatesSelected
    }
  }, [hasDatesSelected, isOpen])

  return {
    hasDatesSelectedOnModalOpenRef,
  }
}
